import { map, pick } from 'lodash'

const transformToSaveAwardsArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, ['id', 'name', 'parentId', 'isCurationEnabled']),
    children: transformToSaveAwardsArgs(node.children),
    position: index,
  }))

export default transformToSaveAwardsArgs
